import { Session } from "@models/ISchema";
import { BlockRanges } from "../context/formData.reducer";

const blockAdapter = (session: Session): BlockRanges => {
  const blockRange = session?.assignment?.blockRange;
  const day = blockRange?.start?.day;
  const startTime = blockRange?.start?.startingTime;
  const endingTime = blockRange?.end?.endingTime;

  const isWithHours = Boolean(day) && Boolean(startTime) && Boolean(endingTime);

  return {
    day,
    days: session?.assignment?.days ?? [],
    startTime,
    endTime: endingTime,
    blocks: session?.blocksCount,
    selected: isWithHours ? "hours" : "blocks",
  };
};

export default blockAdapter;
